var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.333 12.175V6.333H7.667v5.842h-2.5L8.5 15.5l3.333-3.325h-2.5zM3.5.5L.167 3.825h2.5v5.842h1.666V3.825h2.5L3.5.5z",
    fill: "#141414"
  })));
}
export default SvgSwaper;